import { AppDispatch, RootState, store } from '../index';
import { FetchState } from '../fetchState';
import { getList, getListSort, ListFilter, listSlice, ListType } from '../listHelper';
import { CancelToken } from 'axios';
import { EntityState } from '@api/models/enums/EntityState';
import { TrainingDto } from '@api/models/training/TrainingDto';
import { trainingService } from '@api/services/services';

export interface TrainingListFilter extends ListFilter {
  state?: EntityState;
}

export type TrainingListState = ListType<TrainingDto, TrainingListFilter>;

const initialState: TrainingListState = {
  state: FetchState.None,
  data: undefined,
  query: {
    state: EntityState.Active,
    sortBy: 'name',
    sortDesc: false,
  },
};

export const trainingListSlice = listSlice({
  name: 'trainingList',
  initialState,
});

export const selectTrainingList = (state: RootState) => state.trainingList;
export const trainingListActions = trainingListSlice.actions;

export const getTrainingList = (cancelToken: CancelToken) => (dispatch: AppDispatch) => {
  const storeState = store.getState();
  const data = selectTrainingList(storeState);

  const handleGetData = (size: number) => {
    return trainingService.query(
      {
        q: data.query.q,
        state: data.query.state,
        page: data.query.page,
        size: size,
        sort: getListSort(data),
      },
      { cancelToken: cancelToken as any },
    );
  };

  getList({
    dispatch,
    cancelToken,
    state: data.state,
    actions: trainingListActions,
    getData: handleGetData,
  });
};
